module.exports = __webpack_public_path__ + "media/images/realizacje/real4-3fec17486f219da4bcfdae59c6936adc.png";